import { render, staticRenderFns } from "./OrderPartseXpress.vue?vue&type=template&id=5f1c333e&scoped=true"
import script from "./OrderPartseXpress.vue?vue&type=script&lang=js"
export * from "./OrderPartseXpress.vue?vue&type=script&lang=js"
import style0 from "./OrderPartseXpress.vue?vue&type=style&index=0&id=5f1c333e&prod&scoped=true&lang=scss"
import style1 from "./OrderPartseXpress.vue?vue&type=style&index=1&id=5f1c333e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1c333e",
  null
  
)

export default component.exports